import axios from 'axios'
import React, { useEffect, useState } from 'react'
import "./MonitorFunds.css";
import { Admin } from "./Admin.js";
import MyGraph from '../component/myGraph.js';
import MyBarChart from '../component/myBarChart.js';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from './MonitorUserTable.module.css';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

export const MonitorUser = () => {
    const [targetUser, setTargetUser] = useState(undefined);
    const [userData, setUserData] = useState(null);
    const [allUsers, setAllUsers] = useState([]);

    const [userTransactions, setUserTransactions] = useState([]);
    const [categorizedChallenges, setCategorizedChallenges] = useState([]);
    const [depositedFunds, setDepositedFunds] = useState(0);
    const [totalWagered, setTotalWagered] = useState(0);
    const [totalWon, setTotalWon] = useState(0);
    const [totalLost, setTotalLost] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAllUsers = async () => {
            const res = await axios.post("/api/auth/getuserdata");
            setAllUsers(res.data);
        };
        fetchAllUsers();
    }, []);

    const getuserdata = async () => {
        const res = await axios.post(`/api/auth/getcurrentuser`, {
            id: targetUser,
        });
        setUserData(res.data);
    }
    const getusertransactions = async () => {
        const res = await axios.post(`/api/auth/gettransactionloguser`,{
            userid: targetUser,
        });
        if (!Array.isArray(res.data) || res.data.length === 0) {
            setTargetUser(undefined);
            return;
        };
        console.log("My res", res.data);
        setUserTransactions(res.data.slice(0, 51).reverse());
        setDepositedFunds(res.data.filter(transaction => transaction.payment_method).reduce((acc, transaction) => acc + transaction.transaction_amount, 0));
    };

    const getuserchallenges = async () => {
        const res = await axios.post(`/api/auth/challengedata`, {
            id: targetUser,
            Accept: "true",
            result: "declare"
        });

        setTotalWagered(res.data.reduce((acc, challenge) => acc + (challenge.playerwager || 0), 0));
        setTotalWon(res.data.filter(challenge => challenge.winner === targetUser).reduce((acc, challenge) => acc + (challenge.playerwager || 0), 0));
        setTotalLost(res.data.filter(challenge => challenge.loser === targetUser).reduce((acc, challenge) => acc + (challenge.playerwager || 0), 0));

        const soloGameChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.oneplayercompetitivegames > 0);
        const soloGoalChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.oneplayercompetitivegoals > 0);
        const soloPointsChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.solocompetitivepoints > 0);
        const soloSavesChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.solocompetitivesaves > 0);
        const twoPlayerGameChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.twoplayercompetitivegames > 0);
        const twoPlayerGoalChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.twoplayercompetitivegoals > 0);
        const duoAssistsChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.duocompetitiveassists > 0);
        const duoPointsChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.duocompetitivepoints > 0);
        const duoSavesChallenges = res.data.filter(challenge => challenge.category === "solo" && challenge.duocompetitivesaves > 0);
        
        setCategorizedChallenges({
            SoloGames: {
                name: "Solo Games",
                total: soloGameChallenges.length,
                challenges: [...new Set(soloGameChallenges.map(challenge => challenge.oneplayercompetitivegames))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: soloGameChallenges.filter(challenge => challenge.oneplayercompetitivegames === criteria).length
                    })),
            },
            SoloGoals: {
                name: "Solo Goals",
                total: soloGoalChallenges.length,
                challenges: [...new Set(soloGoalChallenges.map(challenge => challenge.oneplayercompetitivegoals))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: soloGoalChallenges.filter(challenge => challenge.oneplayercompetitivegoals === criteria).length
                    })),
            },
            SoloPoints: {
                name: "Solo Points",
                total: soloPointsChallenges.length,
                challenges: [...new Set(soloPointsChallenges.map(challenge => challenge.solocompetitivepoints))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: soloPointsChallenges.filter(challenge => challenge.solocompetitivepoints === criteria).length
                    })),
            },
            SoloSaves: {
                name: "Solo Saves",
                total: soloSavesChallenges.length,
                challenges: [...new Set(soloSavesChallenges.map(challenge => challenge.solocompetitivesaves))]
                    .map(challenge => ({
                        criteria: challenge,
                        count: soloSavesChallenges.filter(ch => ch.solocompetitivesaves === challenge).length
                    })),
            },
            TwoPlayerGames: {
                name: "Duo Games",
                total: twoPlayerGameChallenges.length,
                challenges: [...new Set(twoPlayerGameChallenges.map(challenge => challenge.twoplayercompetitivegames))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: twoPlayerGameChallenges.filter(challenge => challenge.twoplayercompetitivegames === criteria).length
                    })),
            },
            TwoPlayerGoals: {
                name: "Duo Goals",
                total: twoPlayerGoalChallenges.length,
                challenges: [...new Set(twoPlayerGoalChallenges.map(challenge => challenge.twoplayercompetitivegoals))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: twoPlayerGoalChallenges.filter(challenge => challenge.twoplayercompetitivegoals === criteria).length
                    })),
            },
            DuoAssists: {
                name: "Duo Assists",
                total: duoAssistsChallenges.length,
                challenges: [...new Set(duoAssistsChallenges.map(challenge => challenge.duocompetitiveassists))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: duoAssistsChallenges.filter(challenge => challenge.duocompetitiveassists === criteria).length
                    })),
            },
            DuoPoints: {
                name: "Duo Points",
                total: duoPointsChallenges.length,
                challenges: [...new Set(duoPointsChallenges.map(challenge => challenge.duocompetitivepoints))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: duoPointsChallenges.filter(challenge => challenge.duocompetitivepoints === criteria).length
                    })),
            },
            DuoSaves: {
                name: "Duo Saves",
                total: duoSavesChallenges.length,
                challenges: [...new Set(duoSavesChallenges.map(challenge => challenge.duocompetitivesaves))]
                    .map(criteria => ({
                        criteria: criteria,
                        count: duoSavesChallenges.filter(challenge => challenge.duocompetitivesaves === criteria).length
                    })),
            }
        });
        /*
        
        oneplayercompetitivegames = 5 goals
        oneplayergameamount = $10

        oneplayercompetitivegoals
        oneplayergoalamount

        solocompetitivepoints
        solopointsamount

        solocompetitivesaves
        solosavesamount

        twoplayercompetitivegames
        twoplayergameamount

        twoplayercompetitivegoals
        twoplayergoalamount

        duocompetitiveassists
        duoassistsamount

        duocompetitivepoints
        duopointsamount

        duocompetitivesaves
        duosavesamount


        */
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await Promise.all([
                getusertransactions(),
                getuserdata(),
                getuserchallenges(),
            ]);
            setLoading(false);
        };

        if(targetUser) {
            fetchData();
        }
    }, [targetUser]);

    return (
        <div className="user_content">
            <div className="user_slide">
                <Admin />
            </div>
            <div className="container-fluid  table_A">
                <div className="challenge-heading" style={{ padding: "20px" }}>
                    <h1 style={{ marginBottom: "50px" }}>Monitor User</h1>
                    <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={targetUser}
                        label="Age"
                        onChange={(e) => {
                            setTargetUser(e.target.value);
                            setLoading(true);
                        }}
                        className="mui-select"
                        style={{ width: "250px", fontSize: "15px", marginBottom: "20px" }}
                        placeholder='Select a user'
                    >
                        {allUsers.map((items, index) => (
                            <MenuItem key={index} value={items._id}>{items.username}</MenuItem>
                        ))}
                    </Select>
                    {loading ? (
                        <div style={{ color: 'white' }}>Loading...</div>
                    ) : targetUser === undefined ? (
                        <div style={{ color: 'white' }}>Please select a user to monitor.</div>
                    ) : (
                        <div>
                            <h3 style={{ color: 'white', marginBottom: "10px", marginTop: "35px", width: "100%", textAlign: "left" }}>Stats</h3>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'flex-start', backgroundColor: '#00000040', padding: '20px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #000', color: '#FFF' }}>
                                <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0', backgroundColor: '#305b8bff', padding: '10px', borderRadius: '10px' }}>
                                    Current Balance:&nbsp;<span style={{ color: '#1DCADC' }}>${userData?.available_fund ? userData.available_fund.toFixed(2) : "-"}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0', backgroundColor: '#305b8bff', padding: '10px', borderRadius: '10px' }}>
                                    Deposited Funds:&nbsp;<span style={{ color: '#1DCADC' }}>${depositedFunds ? depositedFunds.toFixed(2) : "-"}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0', backgroundColor: '#305b8bff', padding: '10px', borderRadius: '10px' }}>
                                    Total Wagered:&nbsp;<span style={{ color: '#1DCADC' }}>${totalWagered ? totalWagered.toFixed(2) : "-"}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0', backgroundColor: '#305b8bff', padding: '10px', borderRadius: '10px' }}>
                                    Total Won:&nbsp;<span style={{ color: '#1DCADC' }}>${totalWon ? totalWon.toFixed(2) : "-"}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0', backgroundColor: '#305b8bff', padding: '10px', borderRadius: '10px' }}>
                                    Total Lost:&nbsp;<span style={{ color: '#1DCADC' }}>${totalLost ? totalLost.toFixed(2) : "-"}</span>
                                </div>
                            </div>
                            <h3 style={{ color: 'white', marginBottom: "10px", marginTop: "35px", width: "100%", textAlign: "left" }}>Balance</h3>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', backgroundColor: '#00000040', padding: '20px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #000' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '50px' }}>
                                    <MyGraph
                                        width={"800px"}
                                        height={"400px"}
                                        strokeWidth={0.5}
                                        graphOpacity={0.65}
                                        lineOpacity={0.9}
                                        labelPrefix='$'
                                        coordinates={userTransactions.map((transaction, index) => ({
                                            x: index,
                                            y: transaction.balance_after_transaction
                                        }))}
                                    />
                                    <TableContainer component={Paper} className={styles.tableContainer}>
                                        <Table className={styles.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow className={styles.tableHeader}>
                                                    <TableCell className={styles.tableCell}>Index</TableCell>
                                                    <TableCell className={styles.tableCell}>Date</TableCell>
                                                    <TableCell className={styles.tableCell}>Type</TableCell>
                                                    <TableCell className={styles.tableCell}>Amount</TableCell>
                                                    <TableCell className={styles.tableCell}>Balance</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {userTransactions.map((transaction, index) => (
                                                    <TableRow
                                                        key={index}
                                                        className={`${styles.tableRow} ${index % 2 === 0 ? styles.tableRowOdd : styles.tableRowEven}`}
                                                    >
                                                        <TableCell className={styles.tableCell}>{index}</TableCell>
                                                        <TableCell className={styles.tableCell}>{new Date(transaction.createdAt).toLocaleString()}</TableCell>
                                                        <TableCell className={styles.tableCell}>{transaction.ordertype}</TableCell>
                                                        <TableCell className={styles.tableCell} style={{ color: transaction.moneystatus === 'Debited' ? 'red' : 'green' }}>{transaction.transaction_amount}</TableCell>
                                                        <TableCell className={styles.tableCell}>{transaction.balance_after_transaction.toFixed(2)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                            <h3 style={{ color: 'white', marginBottom: "10px", marginTop: "35px", width: "100%", textAlign: "left" }}>Most Played Challenges</h3>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', backgroundColor: '#00000040', padding: '20px', borderRadius: '10px', border: '1px solid #000' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'flex-start', marginBottom: '60px' }}>
                                    <MyBarChart
                                        width={"800px"}
                                        height={"400px"}
                                        strokeWidth={0.5}
                                        graphOpacity={0.65}
                                        barOpacity={0.9}
                                        barColor="#ff4444"
                                        labelPrefix=''
                                        data={Object.values(categorizedChallenges)
                                            .flatMap((categorizedChallenge) =>
                                                categorizedChallenge.challenges?.map((challenge) => ({
                                                    y: challenge.count
                                                })) || []
                                            )
                                            .sort((a, b) => b.y - a.y)
                                            .map((item, index) => ({
                                                x: index,
                                                y: item.y
                                            }))
                                        }
                                    />
                                    <TableContainer component={Paper} className={styles.tableContainer}>
                                        <Table className={styles.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow className={styles.tableHeader}>
                                                    <TableCell className={styles.tableCell}>Index</TableCell>
                                                    <TableCell className={styles.tableCell}>Type</TableCell>
                                                    <TableCell className={styles.tableCell}>Criteria</TableCell>
                                                    <TableCell className={styles.tableCell}>Played</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Object.values(categorizedChallenges)
                                                    .flatMap((categorizedChallenge, categoryIndex) =>
                                                        categorizedChallenge.challenges?.map((challenge, challengeIndex) => ({
                                                            ...challenge,
                                                            categoryName: categorizedChallenge.name,
                                                            key: `${categoryIndex}-${challengeIndex}`
                                                        })) || []
                                                    )
                                                    .sort((a, b) => b.count - a.count)
                                                    .map((challenge, idx) => (
                                                        <TableRow
                                                            key={challenge.key}
                                                            className={`${styles.tableRow} ${idx % 2 === 0 ? styles.tableRowOdd : styles.tableRowEven}`}
                                                        >
                                                            <TableCell className={styles.tableCell}>{idx}</TableCell>
                                                            <TableCell className={styles.tableCell}>{challenge.categoryName}</TableCell>
                                                            <TableCell className={styles.tableCell}>{challenge.criteria}</TableCell>
                                                            <TableCell className={styles.tableCell}>{challenge.count}</TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MonitorUser;
